'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// header

var SlatesSelect = function SlatesSelect(props) {
    var slateOptions = '';
    if (props.slatesForSource.length > 0) {
        slateOptions = _react2.default.createElement(
            'select',
            { value: props.viewSlate, onChange: props.handleSlateChange, id: 'select-slate' },
            _react2.default.createElement(
                'option',
                { value: '0' },
                'Select a slate'
            ),
            props.slatesForSource.map(function (slate, idx) {
                var slateDisplay = (0, _moment2.default)(slate.contest_start_date).format('h:mm A') + ' (' + slate.game_count + ' games) ' + slate.contest_suffix;
                var thisKey = slate.id + '-' + idx;
                return _react2.default.createElement(
                    'option',
                    { key: thisKey, value: slate.id },
                    slateDisplay
                );
            })
        );
    }
    return slateOptions;
};

exports.default = SlatesSelect;


//////////////////
// WEBPACK FOOTER
// ../component-library/build/navigation/SlatesSelect.js
// module id = 874
// module chunks = 0